<template>
  <section :id class="container my-spacing-lg">
    <ClientOnly v-if="webform">
      <LazyWebform :webform />
    </ClientOnly>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphWebformFragment } from '#graphql-operations'

const props = defineProps<ParagraphWebformFragment>()

const { index, siblings } = defineBlokkli({
  bundle: 'webform',
  chunkName: 'rare',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
const webformId = computed(() => props.webform?.first?.id)

const { data: webform } = await useAsyncData(
  () => {
    if (!webformId.value) {
      return Promise.resolve(null)
    }

    return useGraphqlQuery(
      'webformById',
      { id: webformId.value },
      {
        graphqlCaching: {
          client: true,
        },
      },
    ).then((v) => v.data.webformById)
  },
  {
    server: false,
    watch: [id],
  },
)
</script>
